import { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import Button from '@components/Button';
import Popper from '@components/Popper';
import { Typography } from '@components/Typography';

const StyledButtonGroup = styled(ButtonGroup)({
    '& .MuiButtonGroup-firstButton:hover': {
        borderRightColor: 'transparent',
    },
    '& .MuiButtonGroup-lastButton': {
        padding: '8px 0',
    },
});

const SplitButton = ({ className, variant, options = [], disabled }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const onClick = () => options[selectedIndex]?.onClick();

    const handleMenuItemClick = index => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    return (
        <>
            <StyledButtonGroup ref={anchorRef} disabled={disabled} className={className}>
                <Button variant={variant} onClick={onClick}>
                    {options[selectedIndex]?.text || ''}
                </Button>
                <Button variant={variant} size="small" onClick={handleToggle}>
                    <ArrowDropDownIcon />
                </Button>
            </StyledButtonGroup>
            <ClickAwayListener onClickAway={handleClose}>
                <Popper open={open} anchorEl={anchorRef.current}>
                    {options.map((item, index) => (
                        <MenuItem key={item.text} onClick={() => handleMenuItemClick(index)} disabled={item.disabled}>
                            <Typography variant="body2">{item.text}</Typography>
                        </MenuItem>
                    ))}
                </Popper>
            </ClickAwayListener>
        </>
    );
};

export default SplitButton;
